module.exports = __webpack_public_path__ + "d65534944fdf61918a16dafe33592d80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_2021_chart.png
// module id = 1737
// module chunks = 0